import { SET_FORGOT_PASSWORD_STATE } from "../../common/constants/ActionTypes";

const initialState = {
  isValidForgotPswdUser: false,
  forgetPasswordDetails: {
    email: "",
    emailOtpId: "",
    enteredEmailOtp: "",
    password: "",
    type: "",
  },
  securityAnswerList: null,
};

export default function forgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FORGOT_PASSWORD_STATE:
      return {
        ...state,
        isValidForgotPswdUser: action.payload.flgSubmit,
        forgetPasswordDetails: action.payload.submitDetails,
      };
    default:
      return state;
  }
}
